import React from 'react'
import styled from 'styled-components';
import { typeStyle } from '@carvana/showroom-css-theme';

const SignInButton = styled.button`
  border: none;
  background: none;
  ${typeStyle('label-m')};
  color: var(--cvna-color-blue-2);
  font-family: var(--cvna-font-family);
  :hover {
    color: var(--cvna-color-blue-2);
    text-decoration: none;
  }
  ::after {
    content: '';
    width: 0px;
    height: 1px;
    display: block;
    background: var(--cvna-color-blue-2);
    transition: 300ms;
  }
  :hover::after {
    width: 100%;
  }

  :focus {
    outline: none;
  }
`;

type Props = {
  // eslint-disable-next-line react/require-default-props
  onSignin?(): void;
}

export default function SigninButton({onSignin}: Props) {
  return (
    <SignInButton onClick={() => onSignin?.()}>Sign In</SignInButton>
  )
}